import { render, staticRenderFns } from "./QLeadDataTable.vue?vue&type=template&id=dd98308e&scoped=true&"
import script from "./QLeadDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadDataTable.vue?vue&type=style&index=0&id=dd98308e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd98308e",
  null
  
)

export default component.exports